import { type ReactNode } from 'react';
import { cn } from '@/utils/tailwind.util';
export interface FixedBottomFooterProps {
  /** Footer content */
  children: ReactNode;
  /** Additional CSS classes for customization */
  className?: string;
}

/**
 * FixedBottomFooter - 하단 고정 컨테이너
 *
 * @description
 * 화면 하단에 고정되는 범용 컨테이너 컴포넌트입니다.
 * Mobile과 Desktop 모두 지원하며, GPU 가속을 통해 안정적인 렌더링을 보장합니다.
 *
 * Features:
 * - 뷰포트 하단 고정 (`position: fixed`)
 * - GPU 가속 최적화 (`transform: translateZ(0)`)
 * - 커스텀 스타일링 지원 (className prop)
 *
 * @example
 * ```tsx
 * <FixedBottomFooter className="bg-white border-t px-md py-xs">
 *   <Button>Submit</Button>
 * </FixedBottomFooter>
 * ```
 */
export const FixedBottomFooter = ({
  children,
  className
}: FixedBottomFooterProps) => {
  return <div className={cn(
  // Fixed positioning with GPU acceleration
  'fixed inset-x-0 bottom-0', 'z-50', '[backface-visibility:hidden] [transform:translateZ(0)]', className)} data-sentry-component="FixedBottomFooter" data-sentry-source-file="FixedBottomFooter.tsx">
      {children}
    </div>;
};